import { render, staticRenderFns } from "./DispenserEvents.vue?vue&type=template&id=00b6c4e0"
import script from "./DispenserEvents.vue?vue&type=script&lang=js"
export * from "./DispenserEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports